import { genUUID, getCategoriesList, setArticle } from "../repositories/dataRetrieve";
import { Add, ArtTrack, Delete, PhotoCamera, Save } from "@mui/icons-material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackBarMessage} from "../components/index";
import { Offcanvas } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { CircularProgress,
		TextareaAutosize,
		ImageListItemBar,
		InputAdornment,
		OutlinedInput,
		ImageListItem,
		Typography,
		InputLabel,
		IconButton,
		ImageList,
		TextField,
		MenuItem,
		Select,
		Button,
		Stack,
		Grid } from "@mui/material";
import * as Yup from "yup";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const AddArticle = ({ showOffCanvas, handleCloseOffCanvas, data }) => {
	const [snackSeverityArticle, setSnackSeverityArticle] = useState("success");
	const [snackMessageArticle, setSnackMessageArticle] = useState("");
	const [snackOpenArticle, setSnackOpenArticle] = useState(false);
	const [aquisitionDate, setAquisitionDate] = useState(dayjs());
	const [listCategories, setListCategories] = useState([]);
	const [selectedImages, setSelectedImages] = useState([]);
    const [hideDuration, setHideDuration] = useState(1000);
	const [articleReg, setArticleReg] = useState(null);
	const [loading, setLoading] = useState(false);
	const [edit, setEdit] = useState(false);

	const formik = useFormik({
		initialValues: {
			uuid: "",
			descripcion_corta: "",
			descripcion_larga: "",
			categoria: [],
			marca: "",
			modelo: "",
			n_serie: "",
			fecha_adquisicion: dayjs(new Date()),
			costo_adquisicion: "",
			precio_venta: "",
			piezas: "",
            vendidos: "",
			estado_fisico: "0",
			estatus: "0",
			images: []
		},
		validateOnBlur: false,
        validateOnChange: false,
		validationSchema: Yup.object().shape({
			descripcion_corta: Yup.string().required("Se requiere de una descripción para el bien."),
			fecha_adquisicion: Yup.date().required("Se requiere de fecha de adquisición para el bien.")
		}),
		onSubmit: async (values) => {
			setLoading(true);

			if (values.estatus === "0") {
                setHideDuration(1500);
                setSnackSeverityArticle("error");
                setSnackMessageArticle(`Se requiere de la selección del estatus del bien.`);
                setSnackOpenArticle(true);
				setLoading(false);
				return;
			}

			if (values.estado_fisico === "0") {
				setHideDuration(1500);
                setSnackSeverityArticle("error");
                setSnackMessageArticle(`Se requiere de la selección del estado físico del bien.`);
                setSnackOpenArticle(true);
				setLoading(false);
				return;
			}

			const dt = {
                'uuid': articleReg,
				'descripcion_corta': values?.descripcion_corta,
				'descripcion_larga': values?.descripcion_larga,
				'categoria': values?.categoria,
				'marca': values?.marca,
				'modelo': values?.modelo,
				'n_serie': values?.n_serie,
				'fecha_adquisicion': aquisitionDate.toDate(),
				'costo_adquisicion': values?.costo_adquisicion,
				'precio_venta': values?.precio_venta,
				'piezas': values?.piezas,
				'vendidos': values?.vendidos,
				'estado_fisico__uuid': values?.estado_fisico,
				'estatus': values?.estatus,
				'images': selectedImages
            };

			setArticle(dt).then(() => {
				setHideDuration(1000);
				setSnackSeverityArticle("success");
				setSnackMessageArticle("Se guardó el artículo con éxito.");
				setSnackOpenArticle(true);
			}).catch((err) => {
				setHideDuration(4000);
				setSnackSeverityArticle("error");
				setSnackMessageArticle(`Ocurrió un error con el guardado del artículo. Error: ${err}`);
				setSnackOpenArticle(true);
				setLoading(false);
			});
		},
	});

	const handleNew = () => {
		setEdit(false);
		formik.handleReset();
		setSelectedImages([]);
		setAquisitionDate(dayjs(new Date()));
	};

	const handleClose = () => {
		formik.handleReset();
		setEdit(false);
		setLoading(false);
		setSelectedImages([]);
		handleCloseOffCanvas();
	};

	const handleBlur = (field) => {
		formik.setFieldTouched(field, true, true);
	};

	const handleImageChange = (e) => {
		let filesArray = [];

		if (e.target.files) {
			Array.from(e.target.files).map((el) => {
				if (el.size > 10 * 1024 * 1024) {
					setHideDuration(3000);
					setSnackSeverityArticle("error");
					setSnackMessageArticle(`El archivo "${el.name}" es demasiado pesado (máximo 10MB).`);
					setSnackOpenArticle(true);
				} else {
					filesArray.push({
						url: URL.createObjectURL(el),
						file: el
					});
				};
			});

			setSelectedImages((prevImages) => prevImages.concat(filesArray));
		}
	};

	const handleDelete = (index) => {
		setSelectedImages(selectedImages.filter((_, i) => i !== index));
	};

	const getCategories = async () => {
		try {
			const result = await getCategoriesList();

			if (result?.message.toUpperCase() === 'OK') {
				setListCategories(result?.data);
			} else {
				setListCategories([]);
			}
		} catch (error) {
			setSnackSeverityArticle("error");
			setSnackMessageArticle(`Error en la recuperación de la lista de categorías. Error: ${error}`);
			setSnackOpenArticle(true);
		}
	};

	useEffect(() => {
		if (data?.uuid) {
			setEdit(true);
			setArticleReg(data?.uuid);
			setAquisitionDate(dayjs(new Date(data?.fecha_adquisicion.toDate())));
			setSelectedImages(data?.images);
			formik.setValues({ uuid: data?.uuid,
								descripcion_corta: data?.descripcion_corta,
								descripcion_larga: data?.descripcion_larga,
								categoria: data?.categoria,
								marca: data?.marca,
								modelo: data?.modelo,
								n_serie: data?.n_serie,
								fecha_adquisicion: dayjs(new Date(data?.fecha_adquisicion.toDate())),
								costo_adquisicion: data?.costo_adquisicion,
								precio_venta: data?.precio_venta,
								piezas: data?.piezas,
								estado_fisico: data?.estado_fisico__uuid,
								estatus: data?.estatus
							});
		} else {
			setArticleReg(genUUID());
		};

		getCategories();
	}, [data]);

	return (
		<Offcanvas
            placement="end"
            show={showOffCanvas}
            backdrop="true"
            onHide={() => {
                formik.handleReset();
                handleClose();
            }}
            style={{
                borderTopLeftRadius: "10px",
                top: "15%",
                height: "85%",
            }}
            className="resp-offCanvas"
		>
			<Offcanvas.Header closeButton>
				<Grid container sx={{ pt: "25px", px: "16px" }}>
                    <Grid item md={9} xs={8} sx={{ display: "flex", alignItems: "center" }}>
                        <ArtTrack className="me-1" fontSize="large" color='info' />
                        <Typography variant="h5" id="text-modal-header" sx={{ marginLeft: '1rem', display: { xs: 'none', md: 'flex' } }}>{edit ? "Modificar artículo" : "Nuevo registro"}</Typography>
                        <Typography variant="h6" id="text-modal-header" sx={{ marginLeft: '1rem', display: { xs: 'flex', md: 'none' } }}>{edit ? "Modificar artículo" : "Nuevo registro"}</Typography>
                    </Grid>
                    <Grid item md={3} xs={4} sx={{ textAlign: "right", display: 'flex', alignSelf: 'center' }}>
                        <InputLabel id="text-input-label">(*) Obligatorio</InputLabel>
                    </Grid>
                </Grid>
            </Offcanvas.Header>
			<Offcanvas.Body>
				<Grid container justifyContent="space-between" columnSpacing="10px" sx={{ px: "16px", width: '80%', justifySelf: 'center' }}>
					<Grid item xs={12} id="estatus-group" sx={{ mt: "4px", mb: "2px", textAlign: "end" }}>
						<InputLabel id="text-input-label">Estatus</InputLabel>
						<Select
							name="estatus"
							value={formik.values.estatus}
							onChange={formik.handleChange}
							onBlur={() => handleBlur("estatus")}
							error={Boolean(formik.errors.estatus)}
						>
							<MenuItem value="0">
								Seleccione ...
							</MenuItem>
							<MenuItem value='registrado'>
								Registrado
							</MenuItem>
							<MenuItem value='en_venta'>
								En Venta
							</MenuItem>
							<MenuItem value='vendido'>
								Vendido
							</MenuItem>
						</Select>
					</Grid>

					{edit ?
                        <Grid item xs={12} id="uuid-group" sx={{ mt: "4px", mb: "2px" }}>
                            <InputLabel id="text-input-label">ID</InputLabel>
                            <TextField
                                name="uuid"
                                size="small"
                                disabled
                                sx={{ width: "100%" }}
                                value={formik.values.uuid}
                            />
                        </Grid>
                    :
                        null
                    }
                    <Grid item xs={12} id="descripcion_corta-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Descripción corta *</InputLabel>
                        <TextField
                            name="descripcion_corta"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.descripcion_corta}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.descripcion_corta)}
                            onBlur={() => handleBlur("descripcion_corta")}
                        />
                    </Grid>
                    <Grid item xs={12} id="descripcion_larga-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Descripción larga</InputLabel>
                        <TextareaAutosize
                            name="descripcion_larga"
							minRows={3}
                            size="small"
                            style={{ width: "100%" }}
                            value={formik.values.descripcion_larga}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.descripcion_larga)}
                            onBlur={() => handleBlur("descripcion_larga")}
                        />
                    </Grid>
                    <Grid item xs={12} id="categoria-group" sx={{ mt: "4px", mb: "2px" }}>
						<InputLabel id="text-input-label">Categoría</InputLabel>
						<Select
							name="categoria"
							size="small"
                            sx={{ width: "100%" }}
							multiple
							value={formik.values.categoria || []}
							onChange={formik.handleChange}
							error={Boolean(formik.errors.categoria)}
							onBlur={() => handleBlur('categoria')}
						>
							{listCategories.map((item) => (
								<MenuItem value={ item?.uuid } key={ item?.uuid }>
									{ item?.descripcion }
								</MenuItem>
							))}
						</Select>
					</Grid>
                    <Grid item xs={12} id="marca-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Marca</InputLabel>
                        <TextField
                            name="marca"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.marca}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.marca)}
                            onBlur={() => handleBlur("marca")}
                        />
                    </Grid>
                    <Grid item xs={12} id="modelo-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Modelo</InputLabel>
                        <TextField
                            name="modelo"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.modelo}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.modelo)}
                            onBlur={() => handleBlur("modelo")}
                        />
                    </Grid>
                    <Grid item xs={12} id="n_serie-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Número de serie</InputLabel>
                        <TextField
                            name="n_serie"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.n_serie}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.n_serie)}
                            onBlur={() => handleBlur("n_serie")}
                        />
                    </Grid>
					<Grid item xs={12} id="fecha_adquisicion-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Fecha de adquisición *</InputLabel>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
								name="fecha_adquisicion"
								format="DD/MM/YYYY"
								value={aquisitionDate}
								maxDate={dayjs()}
								onChange={(value) => {
									setAquisitionDate(value);
								}}
								error={Boolean(formik.errors.fecha_adquisicion)}
								onBlur={() => handleBlur("fecha_adquisicion")}
								slotProps={{
									textField: {
										fullWidth: true,
										size: "small",
									},
								}}
							/>
						</LocalizationProvider>
					</Grid>
                    <Grid item xs={12} id="costo_adquisicion-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Costo de adquisición</InputLabel>
                        <OutlinedInput
                            name="costo_adquisicion"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.costo_adquisicion}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.costo_adquisicion)}
                            onBlur={() => handleBlur("costo_adquisicion")}
							startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        />
                    </Grid>
                    <Grid item xs={12} id="precio_venta-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Precio de venta</InputLabel>
                        <OutlinedInput
                            name="precio_venta"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.precio_venta}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.precio_venta)}
                            onBlur={() => handleBlur("precio_venta")}
							startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        />
                    </Grid>
                    <Grid item xs={12} id="piezas-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Piezas en existencia:</InputLabel>
                        <OutlinedInput
                            name="piezas"
							type="number"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.piezas}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.piezas)}
                            onBlur={() => handleBlur("piezas")}
							endAdornment={<InputAdornment position="start">pzas.</InputAdornment>}
                        />
                    </Grid>
                    <Grid item xs={12} id="vendidos-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Piezas vendidas:</InputLabel>
                        <OutlinedInput
                            name="vendidos"
							type="number"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.vendidos}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.vendidos)}
                            onBlur={() => handleBlur("vendidos")}
							endAdornment={<InputAdornment position="start">pzas.</InputAdornment>}
                        />
                    </Grid>
					<Grid item xs={12} id="estado_fisico-group" sx={{ mt: "4px", mb: "2px" }}>
						<InputLabel id="text-input-label">Estado Físico *</InputLabel>
						<Select
							sx={{ width: '100%' }}
							size="small"
							name="estado_fisico"
							value={formik.values.estado_fisico}
							onChange={formik.handleChange}
							onBlur={() => handleBlur("estado_fisico")}
							error={Boolean(formik.errors.estado_fisico)}
						>
							<MenuItem value="0">
								Seleccione ...
							</MenuItem>
							<MenuItem value='malo'>
								Malo
							</MenuItem>
							<MenuItem value='regular'>
								Regular
							</MenuItem>
							<MenuItem value='bueno'>
								Bueno
							</MenuItem>
							<MenuItem value='excelente'>
								Excelente
							</MenuItem>
						</Select>
					</Grid>
					<Grid item xs={12} id="images-group" sx={{ mt: "4px", mb: "2px" }}>
						<InputLabel id="text-input-label">Lista de imagenes</InputLabel>
						<Button
							variant="contained"
							component="label"
							startIcon={<PhotoCamera />}
							sx={{ mb: 4, mt: 3 }}
						>
							Seleccionar Imágenes
							<input
								hidden
								accept="image/*, video/*"
								multiple
								type="file"
								onChange={(event) => handleImageChange(event)}
							/>
						</Button>

						<ImageList sx={{ width: '100%' }} cols={4} rowHeight={100}>
							{selectedImages && selectedImages.map((item, index) => (
								<ImageListItem key={index}>
									<img
										src={item.url}
										alt={`upload-${index}`}
										loading="lazy"
										style={{ height: '100%', objectFit: 'cover' }}
									/>
									<ImageListItemBar
										actionIcon={
											<IconButton
												sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
												onClick={() => handleDelete(index)}
											>
												<Delete />
											</IconButton>
										}
									/>
								</ImageListItem>
							))}
						</ImageList>
					</Grid>
                    <Grid item xs={12} mt={2} sx={{ display: "flex", justifyContent: "center" }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            justifyContent='end'
                            sx={{
                                maxHeight: '2rem',
                                display: 'flex',
                                alignSelf: 'center'
                            }}
                        >
                            <Button key="btn-save" disabled={loading} variant="contained" size="small" color="success" startIcon={<Save />} onClick={() => formik.handleSubmit()}>
								{loading ? <CircularProgress sx={{ width: "25px !important", height: "25px !important", color: "#FFF" }}/> : 'Guardar'}
                            </Button>
                            {edit ?
                                <Button key="btn-new" disabled={loading} variant="contained" size="small" color="info" startIcon={<Add />} onClick={() => handleNew()}>
                                    Nuevo
                                </Button>
                            :
                                null
                            }
                        </Stack>
                    </Grid>
                </Grid>
				<SnackBarMessage
					severity={snackSeverityArticle}
					message={snackMessageArticle}
					open={snackOpenArticle}
					onClose={() => {
						setSnackOpenArticle(false);
						if (snackSeverityArticle === 'success') {
							handleClose();
						};
					}}
					hideDuration={hideDuration}
				/>
			</Offcanvas.Body>
		</Offcanvas>
	);
};

export default AddArticle;
